import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "30px",
	height: "30px",
	viewBox: "0 0 30 30",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Shape" }), /* @__PURE__ */ _jsx("g", {
		id: "Symbols",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Header_element/Text_box",
			transform: "translate(-16.000000, -20.000000)",
			fill: "currentColor",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M31,20 C22.72,20 16,26.72 16,35 C16,43.28 22.72,50 31,50 C39.28,50 46,43.28 46,35 C46,26.72 39.28,20 31,20 Z M31,42.5 C30.175,42.5 29.5,41.825 29.5,41 L29.5,35 C29.5,34.175 30.175,33.5 31,33.5 C31.825,33.5 32.5,34.175 32.5,35 L32.5,41 C32.5,41.825 31.825,42.5 31,42.5 Z M32.5,30.5 L29.5,30.5 L29.5,27.5 L32.5,27.5 L32.5,30.5 Z",
				id: "Shape"
			})
		})
	})]
});
export default SvgWarning;
